import React from "react";
import { useHistory } from "react-router-dom";

import useWaitApiCall from "../../../hooks/useWaitApiCall";
import AssessmentByClass from "../../../templates/teacher/AssessmentByClass";
import {
  Context,
  fetchAvgAssessment,
  notFoundPath,
  allAssessmentDistributionPath,
  fetchTemporaryToken,
  clearTemporaryToken,
  updateAssessmentLastActive,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import useDebounceCallback from "../../../hooks/useDebounceCallback";
import useUpdateAssessmentLastActive from "../../../hooks/useUpdateAssessmentLastActive";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const class_id = parseInt(parseQueryParams()["class_id"]);
  const [calling, peep] = useWaitApiCall(state);
  const [loading, setLoading] = React.useState(calling);
  const classes = React.useMemo(
    () => state.teacher.classes.filter(cls => !cls.is_sub),
    [state.teacher.classes],
  );
  const currentClass = React.useMemo(
    () =>
      (classes.length && classes.find(cls => cls.id === Number(class_id))) || {
        id: 0,
        name: "",
        grade: 0,
        charged: false,
        is_sub: false,
        full_name: "",
        assumed_entrance_year: 0,
      },
    [classes, class_id],
  );
  const classIDs = React.useMemo(
    () => (classes ? classes.map(cls => cls.id) : []),
    [classes],
  );

  React.useEffect(() => {
    if (classIDs.length && !classIDs.includes(Number(class_id))) {
      history.push(notFoundPath);
    }
  }, [history, classIDs, class_id]);

  useUpdateAssessmentLastActive(
    state.teacher.assessment_last_active_date ?? null,
    dispatch,
    updateAssessmentLastActive,
  );
  const [debounced] = useDebounceCallback(class_id => {
    dispatch(peep(fetchAvgAssessment(Number(class_id))));
  }, 300);

  React.useEffect(() => {
    if (class_id) {
      setLoading(true);
      debounced(class_id);
    }
  }, [dispatch, debounced, peep, class_id]);

  React.useEffect(() => {
    setLoading(calling);
  }, [calling]);

  const handleDownloadPDF = React.useCallback(() => {
    dispatch(peep(fetchTemporaryToken()));
  }, [dispatch, peep]);

  const handleClearPDFToken = React.useCallback(() => {
    dispatch(clearTemporaryToken());
  }, [dispatch]);

  const redirectAllDistributionPageAction = () => {
    history.push(`${allAssessmentDistributionPath}/${currentClass.id}`);
  };

  return (
    <AssessmentByClass
      calling={loading}
      pdfToken={state.temporaryToken}
      class_id={class_id}
      currentClass={currentClass}
      classIDs={classIDs}
      avgScoresData={state.assessment_avg_scores}
      firstAvgScoresData={
        state.past_assessment_avg_scores.first_assessment_avg_scores
      }
      previousAvgScoresData={
        state.past_assessment_avg_scores.previous_assessment_avg_scores
      }
      distributions={state.distributions}
      redirectAllDistributionPageAction={redirectAllDistributionPageAction}
      onDownloadPDF={handleDownloadPDF}
      onClearPDFToken={handleClearPDFToken}
    />
  );
};
